import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _has from 'lodash/has';
import { InternalEmbed } from 'mlb-internal-embed';
import PlayerContainer from './player-container';

class MediaPlayerWrapper extends React.Component {

    constructor(props) {

        super(props);
        this.internalEmbed = new InternalEmbed();
        this.embedWrapper = null;
        this.getClipId = this.getClipId.bind(this);

    }

    componentDidMount() {

        const {
            content_id,
            contentId,
        } = this.props;

        if (content_id || contentId) {

            console.warn("The prop content_id is deprecated for the MediaPlayer, please provide a metaData object with id instead");

        }

        // If id exists, then create the embed player.
        if (this.getClipId()) {

            this.getEmbedWrapper();

        }

    }

    componentDidUpdate(prevProps) {

        const prevId = _get(prevProps, 'metaData.id');
        const metadata = _get(this.props, 'metaData', {});
        const id = _get(metadata, 'id');

        if (id !== prevId) {

            this.getEmbedWrapper().then((embedWrapper) => {

                if (this.isValidMetadata(metadata)) {

                    embedWrapper.playClipWithMetadata(metadata);

                } else {

                    embedWrapper.playClipBySlug(id);

                }

            });

        }

    }


    getClipId() {

        const {
            metaData,
            content_id,
            contentId,
        } = this.props;

        return metaData.id || content_id || contentId;

    }

    /**
     *
     * @desc Validates metadata object for embed player
     * @param {object} metaData metadata prop object
     * @returns {boolean}
     *
     */
    isValidMetadata(metaData) {

        return [
            'title',
            'slug',
            'duration',
            'date',
            'playbacks',
        ].every((property) => _has(metaData, property));

    }

    /**
     *
     * @desc Gets or creates the embed player wrapper
     * @returns {Promise} promise that will resolve the embed wrapper instance.
     *
     */
    getEmbedWrapper() {

        if (this.embedWrapper) {

            // If player already exists, return existing player
            return Promise.resolve(this.embedWrapper);

        }

        // Take onPlayerLoaded from props and encapsulate the rest in options object
        const {
            onPlayerLoaded,
            onPlayerLoadingError,
            cmsDataRoot,
            dynamicAdConfig,
            ...options
        } = this.props;


        // Internal Embed does not like an invalid metadata object.
        // possible TODO: create a PR in internal embed so this check is handled there.
        //                Sanitize options helper function?
        if (!this.isValidMetadata(options.metaData)) {

            options.contentId = this.getClipId();
            options.metaData = undefined;

        }

        this.internalEmbed.init({
            cmsDataRoot,
            dynamicAdConfig,
        });

        return this.internalEmbed.createPlayer(options)
            .then((embedWrapper) => {

                this.embedWrapper = embedWrapper;
                onPlayerLoaded(embedWrapper);

                return embedWrapper;

            })
            .catch((error) => {

                onPlayerLoadingError(error);
                console.error(error);

            });

    }

    render() {

        const { container } = this.props;

        return (
            <PlayerContainer container={container} />
        );

    }

}

MediaPlayerWrapper.propTypes = {
    container: PropTypes.string.isRequired,
    onPlayerLoaded: PropTypes.func,
    onPlayerLoadingError: PropTypes.func,
};

MediaPlayerWrapper.defaultProps = {
    onPlayerLoaded: () => null,
    onPlayerLoadingError: () => null,
    metaData: {},
    cmsDataRoot: 'https://www.mlb.com',
    dynamicAdConfig: {},
};

export default MediaPlayerWrapper;
